<svelte:options runes={true} />

<script lang="ts">
  import type { Command } from '@commands';
  import { localeManager, platformManager } from '@reactive';
  import { SlTooltipPlacement } from '@ui';
  import { expectDefined } from '@utils';
  import type { Snippet } from 'svelte';
  import Keystroke from './Keystroke.svelte';

  let {
    command,
    placement,
    note,
    children
  }: {
    command: Command;
    placement?: SlTooltipPlacement;
    note?: string;
    children: Snippet;
  } = $props();

  let keyTrigger = $derived.by(() => {
    return expectDefined(platformManager.commandKeyTriggerDisplay(command));
  });
</script>

<style>
  .h-stack {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  .v-stack {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .title {
    font-size: var(--sl-font-size-medium);
    font-weight: bold;
    color: var(--sl-color-neutral-50);
  }

  .description {
    font-size: var(--sl-font-size-small);
    color: var(--sl-color-neutral-300);
  }
</style>

{#snippet titleSection()}
  <div class="h-stack">
    <div class="title">
      {localeManager.localizedString(expectDefined(command.shortName ?? command.name))}
    </div>
    <Keystroke key={keyTrigger}></Keystroke>
  </div>
{/snippet}

{#snippet descriptionSection()}
  <p class="description">
    {localeManager.localizedString(expectDefined(command.description))}
  </p>
{/snippet}

{#snippet noteSection()}
  {#if note}
    <p class="fl-note">{note}</p>
  {/if}
{/snippet}

<sl-tooltip style="--show-delay: 1s" {placement} trigger="hover">
  <div slot="content">
    <div class="v-stack">
      {@render titleSection()}
      {@render descriptionSection()}
      {@render noteSection()}
    </div>
  </div>
  {@render children()}
</sl-tooltip>
